"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCommonDisabled = exports.getCommonFocus = exports.getFocusCss = exports.commonButtonStyles = exports.commonTransition = void 0;
var theme_1 = require("../utils/theme");
exports.commonTransition = {
    transition: 'all .2s linear',
};
exports.commonButtonStyles = __assign(__assign(__assign(__assign({}, theme_1.font), { WebkitTapHighlightColor: theme_1.colors.transparent, alignItems: 'center', border: 'none', borderRadius: '1px', boxSizing: 'border-box', color: theme_1.colors.white, cursor: 'pointer', display: 'inline-flex', fontWeight: theme_1.fontWeights.medium, height: '40px', justifyContent: 'center', lineHeight: '20px', minWidth: '32px', outline: 'none', overflow: 'visible', padding: '2px 16px', position: 'relative', textAlign: 'center', textDecoration: 'none', whiteSpace: 'nowrap' }), exports.commonTransition), { '.ap-icon': {
        marginRight: '4px',
        width: '20px',
    } });
exports.getFocusCss = function (theme) {
    return {
        boxShadow: "0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -2px rgba(0, 0, 0, 0.1)",
    };
};
exports.getCommonFocus = function (theme) {
    return {
        ':focus:enabled': __assign({}, exports.getFocusCss(theme)),
    };
};
exports.getCommonDisabled = function (disabled) {
    if (disabled) {
        return {
            cursor: 'not-allowed',
        };
    }
    return null;
};
//# sourceMappingURL=common.js.map